import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useState } from 'react';

import { useStartCommissionRecalculation } from 'hooks/useStartCommissionRecalculation';
import { queryClient } from 'providers/queryClient';
import { useNotify, useRecordContext } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';
import { CommissionsTabsTaskShowDialog } from 'shared/widgets/CommissionsTabs/CommissionsTabsTask/components/CommissionsTabsTaskShowDialog/CommissionsTabsTaskShowDialog';
import { CommissionsTaskLaunchDialog } from 'shared/widgets/CommissionsTaskLaunchDialog/CommissionsTaskLaunchDialog';
import { CommissionRecalculationTask } from 'types/embedded/commissionRecalculationTask';
import { getId } from 'utils';
import { formatInputInTz } from 'utils/date';
import { getTimezoneByName } from 'utils/getTimezoneByName';

import { WrapperStyled, TopRowStyled } from './CommissionsTabsTaskLaunch.styled';
import { CommissionsTabsTaskLaunchMenu } from './CommissionsTabsTaskLaunchMenu/CommissionsTabsTaskLaunchMenu';

export const CommissionsTabsTaskLaunch: React.FC = () => {
  const notify = useNotify();
  const [openView, setOpenView] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const record = useRecordContext<CommissionRecalculationTask>();
  const taskId = getId(record?.id);

  const createdAtFormatted = record?.createdAt
    ? formatInputInTz(record.createdAt, { format: 'dd.MM.yyyy HH:mm' })
    : EMPTY_FIELD;

  const timezone = getTimezoneByName(record?.timeZone);

  const { mutate: startRecalculation, isPending } = useStartCommissionRecalculation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [Resources.CommissionRecalculationTasks] });
      queryClient.refetchQueries({ queryKey: [Resources.CommissionRecalculationTasks] });
      queryClient.invalidateQueries({ queryKey: [Resources.CommissionRecalculationTasks, taskId] });
      queryClient.invalidateQueries({ queryKey: ['commission_recalculation_statuses'] });
      queryClient.invalidateQueries({ queryKey: [Resources.Commissions] });
      queryClient.invalidateQueries({ queryKey: ['commissions/available_actions'] });

      setOpenConfirm(false);
    },
    onError: (error: any) => {
      notify(error.data?.detail, { type: 'error' });
    },
  });

  const handleView = () => {
    setOpenView(true);
  };

  const onStartRecalculation = async () => {
    if (taskId) {
      await startRecalculation(taskId);
    }
  };

  return (
    <WrapperStyled>
      <TopRowStyled>
        <div>
          <Typography variant="body2">Запуск перерасчёта от: {createdAtFormatted}</Typography>
          <Typography color="textSecondary" variant="body2">
            {timezone?.name} ({timezone?.offset})
          </Typography>
        </div>
        <Button
          label="Запуск"
          onClick={() => {
            setOpenConfirm(true);
          }}
          sx={{ marginLeft: 'auto', marginRight: '16px' }}
          variant="contained"
        />
        <CommissionsTaskLaunchDialog
          isLoading={isPending}
          onClose={() => {
            setOpenConfirm(false);
          }}
          onConfirm={onStartRecalculation}
          open={openConfirm}
        />
        <div>
          <CommissionsTabsTaskLaunchMenu onView={handleView} />
        </div>
      </TopRowStyled>
      <CommissionsTabsTaskShowDialog
        onClose={() => setOpenView(false)}
        open={openView}
        record={record}
      />
    </WrapperStyled>
  );
};
